import { Component, Input, SimpleChanges  } from '@angular/core';
import { NavController } from 'ionic-angular';
import { ApiProvider } from '../../providers/api/api';
import { CommonProvider } from '../../providers/common/common';

@Component({
  selector: 'push-reaction',
  templateUrl: 'push-reaction.html'
})
export class PushReactionComponent {
  @Input() push_data;
  @Input() page;
  reaction_list = [];

  constructor(
    public navCtrl: NavController,
    public apiProv: ApiProvider,
    public comProv: CommonProvider,
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.push_data = changes['push_data'].currentValue;
    let push_id = this.push_data['id'];
    if (this.push_data['for_personal']) {
      push_id = 'personal_' + this.push_data['id'];
    }
    this.push_data['push_id'] = push_id;

    //this.push_data['like_custom_text'] = 'いいね';
    //this.push_data['like_count'] = 500;
    this.setLikeCount();
    console.log('push_data', this.push_data);

    this.reaction_list = this.comProv.getReactionList();
    console.log('reaction_list', this.reaction_list);

    let index = this.reaction_list.findIndex((value) => {
      return (value['push_id'] == this.push_data['push_id']);
    }, this);
    if (index >= 0) {
      this.push_data['is_reacted'] = this.reaction_list[index]['is_reacted'];
    }
  }

  addReaction() {
    if (!this.comProv.isLogin()) {
      this.comProv.alertLogin(this.navCtrl);
      return;
    }
    if (this.push_data['is_click']) {
      return;
    }
    this.push_data['is_click'] = true;
    
    this.apiProv.dispLoader();
    this.apiProv.post(this.push_data['_links']['notification_like_increment']['href'])
    .then(data => {
      this.apiProv.removeLoader();
      this.push_data['is_click'] = false;
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }
      this.dispReaction(true);
    }).catch(error => {
      this.apiProv.removeLoader();
      this.push_data['is_click'] = false;
      this.apiProv.statusError(error, this.navCtrl);
    });
  }

  deleteReaction() {
    if (!this.comProv.isLogin()) {
      this.comProv.alertLogin(this.navCtrl);
      return;
    }
    if (this.push_data['is_click']) {
      return;
    }
    this.push_data['is_click'] = true;
    
    this.apiProv.dispLoader();
    this.apiProv.post(this.push_data['_links']['notification_like_decrement']['href'])
    .then(data => {
      this.apiProv.removeLoader();
      this.push_data['is_click'] = false;
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }
      this.dispReaction(false);
    }).catch(error => {
      this.apiProv.removeLoader();
      this.push_data['is_click'] = false;
      this.apiProv.statusError(error, this.navCtrl);
    });
  }

  dispReaction(is_reacted) {
    let reaction_data = {};
    reaction_data['push_id'] = this.push_data['push_id'];
    reaction_data['is_reacted'] = is_reacted;

    this.push_data['is_reacted'] = is_reacted;

    // リアクション数
    if (is_reacted) {
      ++this.push_data['like_count'];
    } else {
      --this.push_data['like_count'];
      if (this.push_data['like_count'] < 0) {
        this.push_data['like_count'] = 0;
      }
    }
    this.setLikeCount();

    // ユーザアクション保存
    let index = this.reaction_list.findIndex((value) => {
      return (value['push_id'] == this.push_data['push_id']);
    }, this);
    if (index >= 0) {
      this.reaction_list[index] = reaction_data;
    } else {
      this.reaction_list.push(reaction_data);
    }
    localStorage.setItem('reaction_list', JSON.stringify(this.reaction_list));
  }

  setLikeCount() {
    let tmp_count;
    if (this.push_data['like_count'] > 1000000) {
      tmp_count = Math.floor(this.push_data['like_count'] / 1000000);
      this.push_data['like_count_disp'] = tmp_count + 'M';
    } else if (this.push_data['like_count'] > 1000) {
      tmp_count = Math.floor(this.push_data['like_count'] / 1000);
      this.push_data['like_count_disp'] = tmp_count + 'K';
    } else {
      this.push_data['like_count_disp'] = this.push_data['like_count'];
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/push-reaction/push-reaction.ts